import { ObjectTypes } from '../../../../utils/constants';
import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';
import { orderRequestActions as searchPageSliceActions } from '../slice/OrderRequestSlice';
import { getEndDateWithTime, getStartDateWithTime } from '../../../../utils/constants/datetime';
import OrderRequestApi from '../../../../services/api/OrderRequestApi';
import { getUserTimezone } from '../../../../hooks/useAuth';

const getStateSliceForSearchPage = (state) => state.orderRequestSearch;

export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.OrderRequestSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction(
  {
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    objectTypeForSaveUserFilter:
      ObjectTypes.OrderRequestUserFilter
  }
);

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const state = getState();
  const timezone = getUserTimezone(state);
  const searchParamBuilder = (filter) => ({
    orderNumber: filter?.orderNumber ?? '',
    clientIDs: filter.clientIDs ?? [],
    reportAddressIDs: filter.reportAddressIDs ?? [],
    scenarioIDs: filter.scenarioIDs ?? [],
    supplyTypeIDs: filter?.supplyTypeIDs ?? [],
    orderName: filter?.orderName ?? '',
    requesterIDs: filter?.requesterIDs ?? '',
    statusIDs: filter?.statusIDs ?? '',
    dueDateFrom: filter?.dueDateFrom ? getStartDateWithTime(filter?.dueDateFrom, timezone).toISOString() : null,
    dueDateTo: filter?.dueDateTo ? getEndDateWithTime(filter?.dueDateTo, timezone).toISOString() : null,
    flags: filter?.flags ? 1 : 0,
    isRecurring: filter?.isRecurring ?? false,
    rushOrder: filter?.rushOrder ?? false,
    functionality: filter?.functionality ?? 'OrderRequest'
  });

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: OrderRequestApi.searchOrderRequest
  });
};
